// extracted by mini-css-extract-plugin
export default {"article":"input_article__zPE9l","error":"input_error__TKed5","customCheckbox":"input_customCheckbox__9pocn","checkmark":"input_checkmark__pU+WD"};